import { useEmbeddedMobile } from 'global-components/utils/OhsUtility';

import OhsEnvParameters from './OhsEnvParameters';
import OhsEnvUtils from './OhsEnvUtils';

export default function OhsEnv() {
  const isEmbeddedMobile = useEmbeddedMobile();
  let isDevelopment = false;
  if (
    window.location.href.includes(OhsEnvParameters.Dev2URL) ||
    window.location.href.includes(OhsEnvParameters.LocalURL) ||
    window.location.href.includes(OhsEnvParameters.AdaDev)
  ) {
    isDevelopment = true;
  }
  window.Ohs = window.Ohs || {};
  window.Ohs = {
    ...window.Ohs,
    ...{
      Env: {
        isEmbeddedMobile,
        isDevelopment,
      },
      EnvUtils: { ...OhsEnvUtils },
    },
  };
  return null;
}
